import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import "../style/model_profile_loading_style.css";

const ModelProfileLoadingComp = () => {
  return (
    <div className="h-dvh flex flex-col items-center justify-center bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 text-white">
      <ProgressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        className="model-profile-loading-spinner"
      />
      <div className="mt-4 text-pink-300">Loading profile...</div>
    </div>
  );
};

export default ModelProfileLoadingComp; 